module KendoWidgets
{
	export class RadioButtonListClickEvent
	{
		sender: KendoWidgets.RadioButton;
		checked: boolean;
		value: string;
		text: string;
		label: KendoWidgets.Label;
	}

	export class RadioButtonListOptions
	{
		items: RadioButtonItem[];
		checkedValue?: string;
		orientation?: KendoWidgets.OrientationEnum;
		width?: string | number;
		css?: string;
		group?: string;
		enabled?: boolean;

		labelPosition?: KendoWidgets.LabelPositionEnum;
		label?: string;
		labelWidth?: number;

		check?(e: KendoWidgets.RadioButtonListClickEvent): void;
	}

	export class RadioButtonList extends kendo.ui.Widget implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.RadioButtonList; }

		constructor(element: Element, options?: KendoWidgets.RadioButtonListOptions)
		{
			if (options == null)
				options = new KendoWidgets.RadioButtonListOptions();

			if (options.enabled == null) options.enabled = true;
			if (options.group == null) options.group = element.id + "Name";

			//#region Width
			if (options.width == null)
				options.width = "auto";

			if (typeof (options.width) == "number")
			{
				options.width = options.width + "px";
				$(element).css("display", "inline-block");
			}
			$(element).width(options.width);
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			if (options.orientation == null) options.orientation = OrientationEnum.Horizontal;

			if (options.items != null)
			{
				let i = 0;
				for (let radioButtonItem of options.items)
				{
					//#region Radio button
					let input = document.createElement("input");
					input.classList.add("k-radio");
					$(input).attr("type", "radio");
					$(input).attr("name", options!.group!);
					$(input).attr("id", element.id + "RadioButton" + i);
					$(input).attr("value", radioButtonItem.value);
					//#endregion

					//#region Label
					$("#" + input.id + "Label").remove();
					let label = document.createElement("label");
					label.id = input.id + "Label";
					$(label).attr("for", input.id);
					let kendoLabel = $(label).kendoLabel(
						{
							text: radioButtonItem.text,
							class: "k-radio-label"
						}).data("kendoLabel");
					//#endregion

					//#region Orientation
					if (options!.orientation == OrientationEnum.Horizontal && i > 0)
						label.style.cssText += "margin-left: 10px;";
					else if (options!.orientation == OrientationEnum.Vertical)
						label.style.cssText += "width: 100%;";
					//#endregion

					//#region Checked value
					if ((options!.checkedValue != null && options!.checkedValue == radioButtonItem.value) || radioButtonItem.checked === true)
					{
						input.checked = true;

						let radioButton = new RadioButton();
						radioButton.element = input;
						radioButton.value = String(radioButtonItem.value);
						radioButton.text = radioButtonItem.text;
						radioButton.label = kendoLabel;
					}
					//#endregion

					//#region Check
					let checkUserOverride = options!.check;
					$(input).click((e: KendoWidgets.RadioButtonListClickEvent) =>
					{
						// Create radio button
						let radioButton = new RadioButton();
						radioButton.element = input;
						radioButton.value = String(radioButtonItem.value);
						radioButton.text = radioButtonItem.text;
						radioButton.label = kendoLabel;

						that.checked(String(radioButtonItem.value));

						// Create event
						e.sender = radioButton;
						e.checked = input.checked;
						e.value = String(radioButtonItem.value);
						e.text = radioButtonItem.text;
						e.label = kendoLabel;

						if (checkUserOverride != null)
							checkUserOverride(e);
					});
					//#endregion

					element.appendChild(input);
					$(input).after(label);
					i++;
				}
			}

			super(element, options);
			let that = this;
			$(element).addClass("k-radiobuttonlist");

			if (!options.enabled)
				this.disable();

			//#region Label
			if (options.label != null && options.label.length > 0)
			{
				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						fontSize: 14,
						height: 19,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				$(element).prepend(label);

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							label.style.cssText += "display: block";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
						}
						break;
				}
				//#endregion
			}
			//#endregion
		}

		clear()
		{
			for (let radioButton of Array.from(this.element.find(".k-radio")))
				(radioButton as HTMLInputElement).checked = false;
		}

		checked(value?: string)
		{
			let selected = null;
			if (value != null)
			{
				let radioButton = this.getRadioButtonByValue(value);
				if (radioButton != null)
				{
					radioButton.element.checked = true;
					selected = radioButton;
				}
			}

			if (selected == null)
			{
				for (let radioButton of Array.from(this.element.find(".k-radio")))
				{
					if ((radioButton as HTMLInputElement).checked)
					{
						let label = $("#" + radioButton.id + "Label").data("kendoLabel");

						selected = new RadioButton();
						selected.element = radioButton as HTMLInputElement;
						selected.label = label;
						selected.text = (label != null) ? label.text() : "";
						selected.value = (radioButton as HTMLInputElement).value;
						break;
					}
				}
			}
			return selected;
		}

		isChecked(value: string)
		{
			return value == this.checkedValue();
		}

		checkedValue(value?: string)
		{
			let checked = this.checked(value);
			return (checked != null) ? checked.value : null;
		}

		getRadioButtonByValue(value: string)
		{
			// Input button
			let inputButton = this.element.find("[value=" + value + "]")[0] as HTMLInputElement;
			let inputButtonLabel: HTMLLabelElement;
			if (inputButton != null)
			{
				// Label
				inputButtonLabel = this.element.find("#" + inputButton.id + "Label")[0] as HTMLLabelElement;
				let kendoLabel = $(inputButtonLabel).data("kendoLabel");

				// Create radio button
				let radioButton = new RadioButton();
				radioButton.element = inputButton;
				radioButton.value = value;
				radioButton.text = (kendoLabel != null) ? kendoLabel.text() : "";
				radioButton.label = kendoLabel;
				return radioButton;
			}
			else
				return null;
		}

		itemText(value: string, text?: string)
		{
			let radioButton = this.getRadioButtonByValue(value);
			if (text != null)
				radioButton!.label.text(text)

			return radioButton!.label.text();
		}

		items()
		{
			return (this.options as RadioButtonListOptions).items;
		}

		enable()
		{
			for (let item of this.items())
			{
				let radioButton = this.getRadioButtonByValue(String(item.value));
				if (radioButton != null)
					$(radioButton.element).removeAttr("disabled");
			}
		}

		disable()
		{
			for (let item of this.items())
			{
				let radioButton = this.getRadioButtonByValue(String(item.value));
				if (radioButton != null)
					$(radioButton.element).attr("disabled", "disabled");
			}
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion
	}

	RadioButtonList.fn = RadioButtonList.prototype;
	RadioButtonList.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	RadioButtonList.fn.options.name = "RadioButtonList";
	kendo.ui.plugin(RadioButtonList);

	export class RadioButton
	{
		public element: HTMLInputElement;
		public value: string;
		public text: string;
		public label: KendoWidgets.Label;
	}

	export class RadioButtonItem
	{
		public text: string;
		public value: string | number;
		public checked?: boolean;
	}

	export enum OrientationEnum
	{
		Horizontal,
		Vertical
	}
}

interface JQuery
{
	kendoRadioButtonList(options?: KendoWidgets.RadioButtonListOptions): JQuery;
	data(key: "kendoRadioButtonList"): KendoWidgets.RadioButtonList;
}